import React, { FC } from 'react';
import { useModals } from 'hooks/context/modals';
import { MODAL_TEST_IDS } from './const';
import { GenericModal } from './GenericModal';
import { MODAL_TYPES } from './types';

import styles from './styles.module.scss';

export const Modals: FC = () => {
  const { modalType } = useModals();

  if (!modalType) return null;
  let modalContent = null;

  switch(modalType.value) {
    case MODAL_TYPES.GIFT_CARD_GENERIC_ERROR.value:
    case MODAL_TYPES.GIFT_CARD_INSUFFICIENT_FUNDS.value:
    case MODAL_TYPES.GIFT_CARD_NOT_FOUND.value:
      modalContent = <GenericModal modalCategoryTranslationKey={'modals.giftCard'} modalType={modalType}/>
      break;
    case MODAL_TYPES.GIFT_CARD_REMOVE_CONFIRMATION.value:
      modalContent = <GenericModal modalCategoryTranslationKey={'modals.giftCard'} modalType={modalType}/>
      break;
    default:
      return null
  }

  return (
    <dialog className={styles.dialogOverlay} data-testid={MODAL_TEST_IDS.root} open={!modalType}>
      <div className={styles.dialogWrapper}>
        {modalContent}
      </div>
    </dialog>
  );
};
